import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Icon from './atoms/Icon';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center max-w-md w-full mx-4">
          <Icon name="loader" className="h-12 w-12 text-ec-primary-500 animate-spin mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-800">Verificando sesión...</h2>
          <p className="text-gray-600 mt-2">Por favor espere un momento</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;